import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/illustrations/star-blue.svg")